import './AgentChatToolbar.css'
import { IconButton } from '@/components/action/IconButton'
import {
  formatConversationCostUsd,
  type ThinkingLevel,
} from './agentChatMessages'

type Props = {
  conversationCostUsd?: number
  thinkingLevel: ThinkingLevel
  onToggleThinking: () => void
  onNewConversation: () => void
  canNewConversation: boolean
  showPastConversations: boolean
  onTogglePastConversations: () => void
  disabled?: boolean
  collapsible?: boolean
  onHide?: () => void
  wide?: boolean
  onToggleWide?: () => void
}

export function AgentChatToolbar({
  conversationCostUsd,
  thinkingLevel,
  onToggleThinking,
  onNewConversation,
  canNewConversation,
  showPastConversations,
  onTogglePastConversations,
  disabled,
  collapsible,
  onHide,
  wide,
  onToggleWide,
}: Props) {
  return (
    <div className='AgentChatToolbar'>
      {onToggleWide && (
        <IconButton
          className='WideToggle'
          icon={wide ? 'chevronRight' : 'chevronLeft'}
          tooltip={wide ? 'Restore' : 'Expand'}
          aria-label={wide ? 'Restore' : 'Expand'}
          aria-pressed={wide}
          onClick={onToggleWide}
        />
      )}
      {conversationCostUsd != null && !showPastConversations && (
        <span className='Cost' title='Estimated conversation cost'>
          {formatConversationCostUsd(conversationCostUsd)}
        </span>
      )}
      {!showPastConversations && (
        <IconButton
          icon={thinkingLevel === 'high' ? 'lightBulb' : 'regLightBulb'}
          tooltip={thinkingLevel === 'high' ? 'Deeper thinking' : 'Shallow thinking'}
          aria-label={thinkingLevel === 'high' ? 'High thinking' : 'Low thinking'}
          aria-pressed={thinkingLevel === 'high'}
          disabled={disabled}
          onClick={onToggleThinking}
        />
      )}
      {!showPastConversations && (
        <IconButton
          icon='plus'
          tooltip='New conversation'
          disabled={disabled || !canNewConversation}
          onClick={onNewConversation}
        />
      )}
      <IconButton
        icon={showPastConversations ? 'chevronUp' : 'chevronDown'}
        tooltip={showPastConversations ? 'Back to conversation' : 'Past conversations'}
        aria-pressed={showPastConversations}
        disabled={disabled}
        onClick={onTogglePastConversations}
      />
      {collapsible && (
        <IconButton
          icon='chevronRight'
          tooltip='Hide'
          onClick={onHide}
        />
      )}
    </div>
  )
}
